<div class="preview-section">
  <div class="section-label">
    <div class="checkbox-container" *ngIf="textHasPlaceholders">
      <mat-checkbox [(ngModel)]="displayChips">Display placeholders</mat-checkbox>
      <mat-checkbox [(ngModel)]="useSample">Use sample value</mat-checkbox>
    </div>
  </div>
  <div class="chat">
    <div class="yours messages">
      <div class="message last" [innerHtml]="previewHtml"></div>
    </div>
  </div>
</div>